import { APIClient } from '../../helpers/api_helper';
const AxiosClient = new APIClient()

const createProject = (payload) => AxiosClient.post('/project', payload);
const getAllProject = (params) => AxiosClient.get('/project', { ...params });
const getProjectDetails = (projectId) => AxiosClient.get(`/project/${projectId}`);
const updateProjectStatus = (project, payload) => AxiosClient.put(`/project/${project}/status`, { ...payload });
const addProjectUser = (payload) => AxiosClient.post('/project/add/user', payload)
const removeProjectUser = (payload) => AxiosClient.post('/project/remove/user', payload);
const updateProject = (payload, project) => AxiosClient.put(`/project/${project}`, payload)
const deleteProject = (project) => AxiosClient.delete(`/project/${project}`)
const updateProjectInline = (payload, project) => AxiosClient.put(`/project/${project}/inline-edit`, payload)
const updateProjectTagStatus = (payload, project) => AxiosClient.put(`/project/${project}/tag-status`, payload)
const sendMessageToAssignedUser = (payload) => AxiosClient.post('/project-user/send-message', payload)
const updateProjectRating = (payload, project) => AxiosClient.put(`/project/${project}/rating`, payload);
const getProjectDeliverable = (query) => AxiosClient.get(`/project/deliverable`, { ...query })

export {
    createProject,
    getAllProject,
    getProjectDetails,
    updateProjectStatus,
    addProjectUser,
    updateProjectInline,
    removeProjectUser,
    updateProject,
    deleteProject,
    updateProjectTagStatus,
    sendMessageToAssignedUser,
    updateProjectRating,
    getProjectDeliverable
}